/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ask_AiInputs */



/**
* | output |
* | --- |
* | "How much experience do you have with AI tools so far?" |
*
* @param {Onboarding_Ask_AiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_ask_ai = /** @type {((inputs?: Onboarding_Ask_AiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ask_AiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wie viel Erfahrung hast du bisher mit KI-Tools?")
	return /** @type {LocalizedString} */ ("How much experience do you have with AI tools so far?")
});